<template>
  <div>
    <md-table v-model="tasks" v-if="tasks.length">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell
          ><md-checkbox
            v-model="item.done"
            @change="toggleDone(item)"
          ></md-checkbox
        ></md-table-cell>
        <md-table-cell>{{ item.description }}</md-table-cell>
        <md-table-cell>
          <template v-if="item.assignee">
            <md-icon>person</md-icon> {{ item.assignee.given_name }}
            {{ item.assignee.family_name }}
          </template>
        </md-table-cell>
        <md-table-cell>
          <template v-if="item.target_date">
            <md-icon>flag</md-icon>
            {{ toGermanDate(item.target_date) }}</template
          >
        </md-table-cell>
        <md-table-cell align="right">
          <md-button
            class="md-icon-button md-raised md-round md-warning"
            @click="$emit('edit', item)"
          >
            <md-icon>edit</md-icon>
            <md-tooltip md-direction="bottom">Aufgabe bearbeiten</md-tooltip>
          </md-button>
        </md-table-cell>
      </md-table-row>
      <div class="" v-if="false">
        <p class="card-service">{{ from + 1 }} bis {{ to }} von {{ total }}</p>
      </div>
    </md-table>
    <div class="spinner" v-if="loading && !this.tasks.length">
      <md-progress-spinner
        class="md-rose"
        :md-stroke="3"
        :md-diameter="30"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>
    <div
      style="display:flex;justify-content:center"
      v-if="total > pagination.perPage"
    >
      <pagination
        type="rose"
        class="pagination-no-border pagination-success"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  components: {
    pagination: Pagination
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    filter: {
      type: String,
      default: "all"
    }
  },
  watch: {
    active: {
      handler: function(active) {
        if (active) {
          this.get();
        }
      },
      immediate: true
    },
    user(user) {
      if (user && this.active && !this.loading) {
        this.get();
      }
    },
    pagination: {
      handler: "get",
      immediate: false,
      deep: true
    }
  },
  data() {
    return {
      loading: false,
      tasks: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 75, 100]
      },
      total: 0
    };
  },
  computed: {
    user() {
      return this.$store.getters["profile/me"];
    }
  },
  methods: {
    async get() {
      this.loading = true;
      if (this.filter === "assigned" && !this.user) {
        return [];
      }
      let params = {
        include: "assignee,author",
        page: {
          number: this.pagination.currentPage,
          size: this.pagination.perPage
        }
      };

      let filter;
      switch (this.filter) {
        case "assigned":
          filter = { assignee_id: this.user.id, done: 0 };
          break;
        case "all":
          filter = { done: 0 };
          break;
        case "done":
          filter = { done: 1 };
          break;
      }

      await this.$store.dispatch("tasks/list", {
        ...params,
        filter
      });

      this.tasks = this.$store.getters["tasks/list"];
      this.total = this.$store.getters["tasks/listTotal"];

      // If current page was already set higher than actual records exist, reset to first page and refresh
      if (
        this.total <= this.pagination.perPage &&
        this.pagination.currentPage > 1
      ) {
        this.pagination.currentPage = 1;
        this.get();
      }

      this.loading = false;
    },
    async toggleDone(item) {
      try {
        await this.$store.dispatch("tasks/update", {
          type: "tasks",
          id: item.id,
          done: item.done
        });
        await this.$store.dispatch("alerts/success", "Aufgabe aktualisiert.");
      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Ein Fehler ist aufgetreten!"
        );
      }
    }
  }
};
</script>
